import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ spacing, palette }) => ({
  menuItem: {
    fontSize: 18,
    "&:not(:first-child)": {
      borderTop: `solid 1px ${palette.grey[200]}`,
    },
    padding: 0,
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: spacing(2),
  },
  link: {
    display: "flex",
    alignItems: "center",
    padding: spacing(2),
  },
}));

export default useStyles;
